// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1xZRi","disabled":"FileBtn_disabled__2hlKa","warn":"FileBtn_warn__2J9m7","fade":"FileBtn_fade__1DaAD"};